module.exports = __webpack_public_path__ + "static/media/dashsentry-logo.b46c37ff.png";